/*
 *  Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
 *  is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
 *  and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
 *
 *  You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
 *  in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
 *  forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
 *  explicitly covering such access.
 *
 *  The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
 *  which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
 *
 *  ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
 *  CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
 *  INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
 *  OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
 *  THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.
 *
 */

import React, { useEffect, useMemo, useState } from 'react'
import { Feature, Image, Layer, Marker, Popup } from 'react-mapbox-gl'
import { connect, useDispatch, useSelector } from 'react-redux'
import onlineDongleDefault from 'assets/images/online-dongle-default.png'
import onlineDongleHovered from 'assets/images/online-dongle-hovered.png'
import offlineDongleDefault from 'assets/images/offline-dongle-default.png'
import offlineDongleHovered from 'assets/images/offline-dongle-hovered.png'
import DongleStatus from '../DongleStatus'
import { Traces } from '../Traces'

const imageSources = [
  {
    id: 'online-dongle-default',
    url: onlineDongleDefault
  },
  {
    id: 'online-dongle-hovered',
    url: onlineDongleHovered
  },
  {
    id: 'offline-dongle-default',
    url: offlineDongleDefault
  },
  {
    id: 'offline-dongle-hovered',
    url: offlineDongleHovered
  }
]

const Dongles = props => {
  const [hoveredDevice, setHoveredDevice] = useState(null)
  const { dongleReports, dongleHardwareInfos, dongleDeviceID } = useSelector(({ dongleDevices }) => ({ ...dongleDevices }))
  const { map: mapAction, dongleDevices: dongleAction } = useDispatch()
  useEffect(() => {
    if (dongleReports[0]) {
      const { latitude, longitude } = dongleReports[0]
      mapAction.setCenter([longitude, latitude])
    }
  }, [dongleReports[0]?.deviceID])

 useEffect(()=>{
  dongleAction.fetchDongleReports({deviceID: dongleDeviceID, page: 1, pageSize: 10000})
  dongleAction.fetchDongleHardware({deviceID: dongleDeviceID, page: 1, pageSize: 10000})
},[])

  useEffect(()=>{
    if(dongleReports[0]){
      const {latitude, longitude} = dongleReports[0]
      mapAction.setCenter([longitude, latitude])
    }
  },[dongleReports[0]?.deviceID])
  const handleMouseMove = e => {
    const device = getDeviceFromFeature(e)
    if (device && device.deviceID !== hoveredDevice?.deviceID) {
      setHoveredDevice(device)
    }
  }

  const handleMouseLeave = e => {
    setHoveredDevice(null)
  }
  const getDeviceFromFeature = e => {
    let device = null
    if (e.features && e.features[0]) {
      const feature = e.features[0]
      device = dongleReports.find(d => d.deviceID === feature.properties.deviceID)
    }
    return device
  }
  const handleLayerClick = e => {
    const device = getDeviceFromFeature(e)
    if (device && device.deviceID !== hoveredDevice.deviceID) {
      setHoveredDevice(device)
    }
  }
  const hoveredHardwareInfo = useMemo(() => {
    return dongleHardwareInfos.find(item => item.device_id === hoveredDevice?.deviceID)
  }, [hoveredDevice?.deviceID])

  return (
    <>
      {hoveredDevice && (
        <Popup
          coordinates={[hoveredDevice.lon, hoveredDevice.lat]}
          style={{ padding: 0 }}
          anchor='bottom'
          offset={[0, -20]}
        >
          <DongleStatus device={{ ...hoveredDevice, ...hoveredHardwareInfo }} />
        </Popup>
      )
      }

      {
        imageSources.map((source, index) => (
          <Image {...source} key={index} />
        ))
      }
      <Layer
        type='symbol'
        source='point'
        layout={{
          'icon-image': ['get', 'icon-image'],
          'icon-size': 0.34,
          'visibility': 'visible',
          'icon-allow-overlap': true,
          'text-allow-overlap': true,
          'icon-ignore-placement': true,
          'symbol-z-order': 'source',
          'symbol-sort-key': 999
        }}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        onClick={handleLayerClick}
      >
        {dongleReports
          .filter((item,index)=> index === 0)
          .map((dongle, index) => {
          const isHovered = hoveredDevice && hoveredDevice.deviceID === dongle.deviceID
          const iconImage = `${dongle.onlineStatus ? 'online' : 'offline'}-dongle-${isHovered ? 'hovered' : 'default'}`
          return (
            <Feature
              properties={{
                'icon-image': iconImage,
                deviceID: dongle.deviceID
              }}
              key={index}
              // id={(dongle.deviceID) as any}
              coordinates={[dongle.longitude, dongle.latitude]}
            />
          )
        })}

      </Layer>
      <Traces traces={[dongleReports]} />
    </>
  )
}
export default Dongles
